import React from 'react'
const SvgProvide5 = props => (
  <svg id='provide5_svg___\u56FE\u5C42_2' viewBox='0 0 46 46' {...props}>
    <defs>
      <style>{'.provide5_svg__cls-1{fill:#fd5c1f}'}</style>
    </defs>
    <g id='provide5_svg___\u56FE\u5C42_1-2'>
      <path
        className='provide5_svg__cls-1'
        d='M19.33 14.11l4.59-.41-.18-1.99-8.85.79 16.65 16.65 1.41-1.41-13.62-13.63zM13.04 18.26l13.63 13.63-4.59.41.18 1.99 8.85-.79-16.65-16.65-1.42 1.41z'
      />
      <path
        d='M42.77 15.5H30.5V3.23C30.5 1.45 29.05 0 27.27 0H3.23C1.45 0 0 1.45 0 3.23v24.05c0 1.78 1.45 3.23 3.23 3.23H15.5v12.27c0 1.78 1.45 3.23 3.23 3.23h24.04c1.78 0 3.23-1.45 3.23-3.23V18.73c0-1.78-1.45-3.23-3.23-3.23zM44 42.77c0 .68-.55 1.23-1.23 1.23H18.73c-.68 0-1.23-.55-1.23-1.23V28.5H3.23c-.68 0-1.23-.55-1.23-1.23V3.23C2 2.55 2.55 2 3.23 2h24.04c.68 0 1.23.55 1.23 1.23V17.5h14.27c.68 0 1.23.55 1.23 1.23v24.05z'
        fill='#2b4b67'
      />
    </g>
  </svg>
)
export default SvgProvide5
